module.exports = __webpack_public_path__ + "static/img/10.0dd3e11.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/3/1/sp/10.png
// module id = P7TW
// module chunks = 0